import React from "react";
import { useTrackerImageUrl } from "@/hooks/useTrackerImageUrl";
import Image from "next/image";

interface StageIconProps {
  iconfile: string;
  title: string;
  isActive?: boolean;
}

export function StageIcon({ iconfile, title, isActive = true }: StageIconProps) {
  const loader1 = "/icons/toast/loader1.svg";
  const { data, isLoading } = useTrackerImageUrl(iconfile);
  const initials = title
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

  return (
    <div
      className={`relative mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center ${
        isActive ? "" : "opacity-50"
      }`}
    >
      {iconfile || data?.data ? (
        <Image
          src={isLoading ? loader1 : data?.data || iconfile}
          alt={title}
          fill
          sizes="36px"
          className="object-contain"
          unoptimized
        />
      ) : (
        <span className="text-[10px] font-semibold text-primary-600">
          {initials || "S"}
        </span>
      )}
    </div>
  );
}
